"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValuesOf = exports.shouldPolyfill = void 0;
var should_polyfill_1 = require("./should-polyfill");
Object.defineProperty(exports, "shouldPolyfill", {
  enumerable: true,
  get: function get() {
    return should_polyfill_1.shouldPolyfill;
  }
});
var src_1 = require("./src");
Object.defineProperty(exports, "supportedValuesOf", {
  enumerable: true,
  get: function get() {
    return src_1.supportedValuesOf;
  }
});